// extracted by mini-css-extract-plugin
export default {"overlay":"wD-z","bodyOpen":"xD-z","content":"yD-z","header":"zD-z","close":"AD-z","closeNoHeading":"BD-z"};